import React from 'react'
import {
    Table, Container,
    Row, Col,
    Label, Input, Button
} from 'reactstrap'
import {
    getAllAddons,
    updateAllAddons,
    updateAllAddonsCostOrderIndex,
    insertAllAddons,
    deleteAllAddons,
    updateSignType,
    insertSignType,
    deleteSignType,
} from '../model/request/addons'
import {
    getTypes,
} from '../model/request/quotes'
import {
    AddonWithOptions,
    SignType,
} from '../model/Sign'
import {
    AlertModalModel
} from './modal/AlertModalController'
import {
    MemoryNumberTextField
} from '../view/MemoryTextField'
import {
    InfoButton,
} from '../view/InfoButton'
import {
    IoIosArrowUp,
    IoIosArrowDown,
} from 'react-icons/io';

function sortAddons(addons) {
    return addons.sort((lhs, rhs) => {
        if (lhs.type_id !== rhs.type_id) {
            if (lhs.type_id == null) {
                return 1
            }
            if (rhs.type_id == null) {
                return -1
            }
            if (lhs.type_id < rhs.type_id) {
                return -1
            }
            if (lhs.type_id > rhs.type_id) {
                return 1
            }
            return 0
        }
        if (lhs.cost_order_index !== rhs.cost_order_index) {
            return lhs.cost_order_index - rhs.cost_order_index
        }
        return lhs.order_index - rhs.order_index
    })
}

class AddonsAdderViewController extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            'addons': [],
            'types': [],
            'typesToHeaderLabels': {null: []},
            'minimizeTypes': [],
            'minimizeHeaders': {},
            'minimizeAddons': [],
        }
    }

    componentDidMount() {
        this.props.turnOnLoader(2)
        getTypes().then(
            (result) => {
                const types = result.data.types
                    .map((type) => SignType.from(type))
                    .sort((a, b) => a.order_index - b.order_index)

                // Self-heals ties/gaps rather than just trusting whatever
                // order_index values already exist - moveType() below
                // swaps two types' order_index values on reorder, which
                // does nothing when they're tied (e.g. both 0): the
                // on-screen order changes immediately, but since neither
                // value actually changed, a fresh load has no real
                // order_index difference to sort by and can put them
                // back in either order. Renumbering to a clean,
                // gap/tie-free 0..N-1 sequence here - and persisting any
                // correction immediately - means every future swap
                // always operates on genuinely different values.
                const corrections = []
                for (let i = 0; i < types.length; i++) {
                    if (types[i].order_index !== i) {
                        types[i].order_index = i
                        corrections.push(types[i])
                    }
                }
                if (corrections.length > 0) {
                    Promise.all(corrections.map((type) => updateSignType(type)))
                        .catch((error) => this.props.showError(error))
                }

                this.setState((state) => {
                    const labels = state.typesToHeaderLabels
                    for (let i = 0; i < types.length; i++) {
                        if (!(types[i].id in labels)) {
                            labels[types[i].id] = []
                        }
                    }

                    return {
                        'types': types,
                    }
                })
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
        getAllAddons().then(
            (result) => {

                result.data.addons = sortAddons(result.data.addons)

                this.setState((state) => {
                    let typesToHeaderLabels = state.typesToHeaderLabels
                    for (let i = 0; i < result.data.addons.length; i++) {
                        if (!(result.data.addons[i].type_id in typesToHeaderLabels)) {
                            typesToHeaderLabels[result.data.addons[i].type_id] = []
                        }

                        if (typesToHeaderLabels[result.data.addons[i].type_id]
                            .indexOf(result.data.addons[i].cost_label) === -1) {

                            typesToHeaderLabels[result.data.addons[i].type_id].push(
                                result.data.addons[i].cost_label)
                        }
                    }

                    return {
                        'addons': result.data.addons.map((addon) => {
                            addon = AddonWithOptions.from(addon)
                            addon.header_label = addon.cost_label
                            return addon
                        }),
                        'typesToHeaderLabels': typesToHeaderLabels,
                    }
                })
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    // MARK: Button Actions

    updateAddon(addon) {
        this.props.turnOnLoader()
        updateAllAddons(addon).then(
            (result) => {
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    postAddon(addon) {
        this.props.turnOnLoader()
        insertAllAddons(addon).then(
            (result) => {
                let addons = this.state.addons
                addons = addons.filter(item => item !== addon)
                addon = Object.assign({}, addon)
                addon = Object.assign(addon, result.data.addon)
                addon = AddonWithOptions.from(addon)
                addon.is_local = false
                addons.push(addon)
                this.setState({
                    'addons': addons,
                })
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    insertAddon(addon, keepOptions=false) {
        addon = Object.assign({}, addon)
        addon.is_local = true
        addon.id = ''
        if (!keepOptions) {
            addon.options = []
        }
        addon = AddonWithOptions.from(addon)
        const addons = this.state.addons
        addon.order_index = Number.parseInt(addon.order_index) + 1
        addons.push(addon)
        this.setState({
            'addons': addons,
        })
    }

    deleteAddon(addon) {
        this.props.turnOnLoader()
        deleteAllAddons(addon.id).then(
            (result) => {
                const addons = this.state.addons.filter((x) => 
                    x.id !== addon.id
                )
                this.setState({
                    'addons': addons,
                })
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }


    deleteType(typeId, warningMsg=0) {
        if (this.state.addons.filter((addon) => addon.type_id === typeId).length !== 0) {
            this.props.showAlertModal((new AlertModalModel())
                .setTitle('Error')
                .setMessage(
                    'You must delete all addons first. We want to make sure you actually want to do this',
                )
                .addOkButton(() => {
                    this.props.closeModal()
                })
            )
            return
        }

        const messages = [
            'I really want to clarify this as you cannot undo this action.',
            'You may want to think about this for a week.',
            'The only way back is to remake all of the addons for this type.',
            'Click cancel unless you know for sure what you are doing.',
            'This is the last message. Make sure to refresh the page afterwards.',
        ]
        if (warningMsg === messages.length) {
            this.props.turnOnLoader()
            deleteSignType(typeId).then(
                (result) => {
                    this.setState((state) => {
                        state.addons = state.addons.filter((x) => x.type_id !== typeId)
                        state.types = state.types.filter((x) => x.id !== typeId)
                        return {
                            'addons': state.addons,
                            'types': state.types,
                        }
                    })
                    this.props.turnOffLoader()
                },
                (error) => {
                    this.props.showError(error)
                    this.props.turnOffLoader()
                }
            )
            return
        }
        this.props.showAlertModal((new AlertModalModel())
            .setTitle('Are you sure?')
            .setMessage(
                'You will delete all the addons associated with this ' +
                'process. ' + messages[warningMsg],
            )
            .addYesButton(() => {
                this.props.closeModal()
                this.deleteType(typeId, warningMsg+1)
            })
            .addCancelButton(() => {
                this.props.closeModal()
            })
        )
    }


    // MARK: render

    renderMoveUpDownArrows(upArrowId, downArrowId, onClickUpArrow, onClickDownArrow) {
        return <div>
            <Button
                id={upArrowId}
                style={{
                    'height': '10pt',
                    'margin': '0pt',
                    'padding': '0pt',
                    'marginTop': '-10pt',
                }}
                size='sm'
                onClick={(e) => {
                    onClickUpArrow()
                }}>
                <IoIosArrowUp
                    style={{
                        'margin-top': '-10pt',
                        'margin': '0pt',
                        'padding': '0pt',
                        'fontSize': '10pt',
                        'fontWeight': 'bold',
                        'marginTop': '-10pt',
                    }}/>
            </Button>
            <Button
                id={downArrowId}
                style={{
                    'height': '10pt',
                    'margin': '0pt',
                    'padding': '0pt',
                    'marginTop': '-10pt',
                }}
                size='sm'
                onClick={(e) => {
                    onClickDownArrow()
                }}>
                <IoIosArrowDown
                    style={{
                        'margin-top': '-10pt',
                        'margin': '0pt',
                        'padding': '0pt',
                        'fontSize': '10pt',
                        'fontWeight': 'bold',
                        'marginTop': '-10pt',
                    }}/>
            </Button>
        </div>
    }

    renderMoveUpDownArrowsGivenArray(id, index, arr, changeOrderIndex) {
        return this.renderMoveUpDownArrows(
            id + '-move-sign-up-button-' + index,
            id + '-move-sign-down-button-' + index,
            () => {
                if (index - 1 >= 0) {
                    if (changeOrderIndex) {
                        arr[index].order_index -= 1
                        arr[index-1].order_index += 1
                    }
                    const signAbove = arr[index-1]
                    arr[index-1] = arr[index]
                    arr[index] = signAbove
                    this.setState({})
                    document.getElementById(
                        id + '-move-sign-up-button-' + (index-1)
                    ).focus()
                }
            }, () => {
                if (index + 1 < arr.length) {
                    if (changeOrderIndex) {
                        arr[index].order_index += 1
                        arr[index+1].order_index -= 1
                    }
                    const signAbove = arr[index+1]
                    arr[index+1] = arr[index]
                    arr[index] = signAbove
                    this.setState({})
                    document.getElementById(
                        id + '-move-sign-down-button-' + (index+1)
                    ).focus()
                }
            },
        )
    }

    renderAddonGroupOption(addon, groupIndex) {
        return <Container>
            {this.renderMoveUpDownArrowsGivenArray('group-' + addon.id + '-',
                groupIndex, addon.options, false)}
            <Label style={{
                'fontSize': '20px',
                'fontWeigt': '400',
            }}>Drop Down Section {groupIndex + 1}</Label>
            <Table>
                <thead>
                    <tr>
                        <th></th>
                        <th>Label</th>
                        <th>PDF Label</th>
                        <th>Square Inch Price</th>
                        <th>Unit Price</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        addon.options[groupIndex].map((item, index) => {
                            return <tr>
                                <td>
                                    {this.renderMoveUpDownArrowsGivenArray
                                        ('option-'+addon.id+'-'+groupIndex+'-',
                                            index, addon.options[groupIndex], false)}
                                </td>
                                <td>
                                    <Input
                                        value={item.label}
                                        onChange={(e) => {
                                            item.label = e.target.value
                                            this.setState({})
                                        }}
                                    />
                                </td>
                                <td>
                                    <Input
                                        value={item.pdf_label}
                                        onChange={(e) => {
                                            item.pdf_label = e.target.value
                                            this.setState({})
                                        }}
                                    />
                                </td>
                                <td>
                                    <Input
                                        value={item.square_inch_price}
                                        onChange={(e) => {
                                            item.square_inch_price = e.target.value
                                            this.setState({})
                                        }}
                                    />
                                </td>
                                <td>
                                    <Input
                                        value={item.unit_price}
                                        onChange={(e) => {
                                            item.unit_price = e.target.value
                                            this.setState({})
                                        }}
                                    />
                                </td>
                                <td>
                                    <Button onClick={(e) => {
                                        addon.removeOptionItem(groupIndex, index)
                                        this.setState({
                                            'addons': this.state.addons,
                                        })
                                    }}>Remove</Button>
                                </td>
                            </tr>
                        })
                    }
                    <tr>
                        <td colspan="4" />
                        <td>
                            <Button onClick={(e) => {
                                addon.addOptionItem(groupIndex)
                                this.setState({
                                    'addons': this.state.addons,
                                })
                            }}>Add Item</Button>
                        </td>
                    </tr>
                </tbody>
            </Table>
        </Container>
    }

    renderAddonGroupOptions(addon) {
        return <Container>
            {addon.options.map((options, index) => {
                return <Row>
                    <Col>
                        {this.renderAddonGroupOption(addon, index)}
                    </Col>
                </Row>
            })}
            <Row><Col>
                <Button onClick={(e) => {
                    addon.addOption()
                    this.setState({
                        'addons': this.state.addons,
                    })
                }}>Add Group</Button>
            </Col></Row>
        </Container>
    }

    renderAddon(addon, index, addons) {
        const previousAddon = addons[index-1]
        const nextAddon = addons[index+1]
        const upId = 'cost-move-sign-' + addon.type_id + '-' + addon.header_label + '-up-button-'
        const downId = 'cost-move-sign-' + addon.type_id + '-' + addon.header_label + '-down-button-'
        return <>
           <tr>
                <td>
                    {this.renderMoveUpDownArrows(
                        upId + index,
                        downId + index,
                        () => {
                            if (previousAddon) {
                                addon.order_index = index-1
                                previousAddon.order_index = index
                                this.setState({})
                                document.getElementById(
                                    upId + (index-1)
                                ).focus()
                            }
                        }, () => {
                            if (nextAddon) {
                                addon.order_index = index+1
                                nextAddon.order_index = index
                                this.setState({})
                                document.getElementById(
                                    downId + (index+1)
                                ).focus()
                            }
                        },
                    )}
                </td>
                <td>
                    <Input value={addon.cost_label} onChange={(e) => {
                        const addons = this.state.addons
                        const index = addons.findIndex((x) => x === addon)
                        addons[index].cost_label = e.target.value
                        this.setState({
                            'addons': addons,
                        })
                    }}/>
                </td>
                <td>
                    <MemoryNumberTextField
                        value={addon.cost_order_index}
                        onHitEnter={(newValue) => {
                        const addons = this.state.addons
                        const index = addons.findIndex((x) => x === addon)
                        addons[index].cost_order_index = newValue
                        this.setState({
                            'addons': addons,
                        })
                    }}/>
                </td>
                <td>
                    {addon.labelForZeroPicks()}
                </td>
                <td>
                    <MemoryNumberTextField
                        value={addon.order_index}
                        onHitEnter={(newValue) => {
                        const addons = this.state.addons
                        const index = addons.findIndex((x) => x === addon)
                        addons[index].order_index = newValue
                        this.setState({
                            'addons': addons,
                        })
                    }}/>
                </td>
                <td>
                    <Input
                        type="checkbox"
                        checked={addon.inuse}
                        onChange={(e) => {
                            const addons = this.state.addons
                            const index = addons.findIndex((x) => x === addon)
                            addons[index].inuse = !addons[index].inuse
                            this.setState({
                                'addons': addons
                            })
                        }}/>
                </td>
                <td>
                    <Button
                        onClick={(e) => {
                            if (this.state.minimizeAddons.find((x) => x === addon)) {
                                this.setState((state) => {
                                    return {
                                        'minimizeAddons': state.minimizeAddons.filter((x) =>
                                            x !== addon
                                        )
                                    }
                                })
                            } else {
                                this.setState((state) => {
                                    state.minimizeAddons.push(addon)
                                    return {
                                        'minimizeAddons': state.minimizeAddons
                                    }
                                })
                            }
                        }}
                    >
                    {
                        this.state.minimizeAddons.find((x) => x === addon) ?
                            <IoIosArrowDown
                                style={{
                                    'fontSize': '20pt',
                                    'fontWeight': 'bolder',
                                }}/>
                        : <IoIosArrowUp
                                style={{
                                    'fontSize': '20pt',
                                    'fontWeight': 'bolder',
                                }}/>
                    }
                    </Button>
                </td>
                <td>
                { addon.is_local ?
                    <Button color="success" onClick={(e) =>
                        this.postAddon(addon)
                    }>New</Button>
                    :
                    <Button color="success" onClick={(e) =>
                        this.updateAddon(addon)
                    }>Update</Button>
                }
                </td>
                <td>
                    <Button
                        disabled={addon.is_local}
                        color="danger"
                        onClick={(e) =>
                            this.props.showAlertModal((new AlertModalModel())
                                .setTitle('Are you sure?')
                                .setMessage(
                                    'Do you want to delete this addon and all groups.',
                                )
                                .addYesButton(() => {
                                    this.deleteAddon(addon)
                                    this.props.closeModal()
                                })
                                .addCancelButton(() => {
                                    this.props.closeModal()
                                })
                            )
                        }
                    >Delete</Button>
                </td>
                <td>
                    <Button
                        className='btn btn-copy'
                        onClick={(e) =>
                            this.insertAddon(addon, true)
                        }
                    >Copy</Button>
                </td>
            </tr>
            {this.state.minimizeAddons.find((x) => x === addon) ?
                <tr>
                    <td colspan="1" />
                    <td colspan="6">
                        { this.renderAddonGroupOptions(addon) }
                    </td>
                </tr>
                : <></>
            }
        </>
    }

    renderCostLabel(addons, index, headerLabels) {
        if (addons.length === 0) {
            return <></>
        }
        addons.sort((lhs, rhs) => lhs.order_index - rhs.order_index)

        const isMinimized =
            !(addons[0].type_id in this.state.minimizeHeaders) ||
            this.state.minimizeHeaders[addons[0].type_id].find(
                (x) => x === addons[0].header_label) === undefined

        // addons = addons.sort((l, r) => l.order_index - r.order_index)
        // .map((addon, index) => {
        //     addon.order_index = index
        //     return addon
        // })
        const upArrowId = addons[0].type_id + '-move-cost-order-index-up-button-'
        const downArrowId = addons[0].type_id + '-move-cost-order-index-down-button-'
        return <>
            <Label
                style={{
                    'fontSize': '24px',
                    'fontWeight': '550',
                }}
            >{addons[0].header_label}</Label>
            {this.renderMoveUpDownArrows(
                upArrowId + index,
                downArrowId + index,
                () => {
                    if (index === 0) {
                        return
                    }
                    this.setState((state) => {
                        for (let i = 0; i < state.addons.length; i++) {
                            if (
                                state.addons[i].type_id === addons[0].type_id &&
                                state.addons[i].header_label === addons[0].header_label &&
                                state.addons[i].cost_label === addons[0].header_label
                            ) {
                                state.addons[i].cost_order_index = index-1
                            }

                            if (
                                state.addons[i].type_id === addons[0].type_id &&
                                state.addons[i].header_label === headerLabels[index-1] &&
                                state.addons[i].cost_label === headerLabels[index-1]
                            ) {
                                state.addons[i].cost_order_index = index
                            }
                        }

                        headerLabels.swapNoCopy(index-1, index)

                        document.getElementById(
                            upArrowId + (index-1)
                        ).focus()

                        return {
                            'addons': state.addons,
                        }
                    })
                },
                () => {
                    if (index+1 >= headerLabels.length) {
                        return
                    }
                    this.setState((state) => {
                        for (let i = 0; i < state.addons.length; i++) {
                            if (
                                state.addons[i].type_id === addons[0].type_id &&
                                state.addons[i].header_label === addons[0].header_label &&
                                state.addons[i].cost_label === addons[0].header_label
                            ) {
                                state.addons[i].cost_order_index = index+1
                            }

                            if (
                                state.addons[i].type_id === addons[0].type_id &&
                                state.addons[i].header_label === headerLabels[index+1] &&
                                state.addons[i].cost_label === headerLabels[index+1]
                            ) {
                                state.addons[i].cost_order_index = index
                            }
                        }

                        headerLabels.swapNoCopy(index+1, index)

                        document.getElementById(
                            downArrowId + (index+1)
                        ).focus()

                        return {
                            'addons': state.addons,
                        }
                    })
                },
            )}
            <MemoryNumberTextField
                style={{
                    'maxWidth': '400px',
                }}
                value={addons[0].cost_order_index}
                onHitEnter={(newValue) => {
                    this.setState((state) => {
                        for (let i = 0; i < state.addons.length; i++) {
                            if (
                                state.addons[i].type_id === addons[0].type_id &&
                                state.addons[i].header_label === addons[0].header_label &&
                                state.addons[i].cost_label === addons[0].header_label
                            ) {
                                state.addons[i].cost_order_index = newValue
                            }
                        }

                        return {
                            'addons': state.addons,
                        }
                    })
                }}
            />
            <Button
                color='success'
                onClick={(e) => {
                    this.props.showAlertModal((new AlertModalModel())
                        .setTitle('Are you sure?')
                        .setMessage(
                            'This will update all addons under ' + (
                                this.state.types.find((x) => x.id === addons[0].type_id).label
                            ) + '->' + addons[0].header_label +
                            ' and set the group order index to be ' + addons[0].cost_order_index
                        )
                        .addYesButton(() => {
                            this.props.turnOnLoader()
                            updateAllAddonsCostOrderIndex(addons[0].type_id,
                                addons[0].header_label, addons[0].cost_order_index)
                            .then(
                                (result) => {
                                    this.props.turnOffLoader()
                                },
                                (error) => {
                                    this.props.turnOffLoader()
                                }
                            )

                            this.props.closeModal()
                        })
                        .addNoButton(() => {
                            this.props.closeModal()
                        })
                    )
                }}
            >Update Head Order Index</Button>
            <Button
                style={{
                    'marginLeft': '8pt',
                }}
                onClick={(e) => {
                    if (isMinimized) {
                        const headers = this.state.minimizeHeaders
                        if (!(addons[0].type_id in headers)) {
                            headers[addons[0].type_id] = []
                        }
                        headers[addons[0].type_id].push(addons[0].header_label)
                        this.setState({
                            'minimizeHeaders': headers,
                        })
                    } else {
                        let types = this.state.minimizeHeaders
                        types[addons[0].type_id] = types[addons[0].type_id]
                            .filter((x) => x !== addons[0].header_label)
                        this.setState({
                            'minimizeHeaders': types,
                        })
                    }
                }}
                >{isMinimized ?
                    <IoIosArrowUp
                        style={{
                            'fontSize': '20pt',
                            'fontWeight': '500',
                        }}/>
                    : <IoIosArrowDown
                        style={{
                            'fontSize': '20pt',
                            'fontWeight': '500',
                        }}/>
                }</Button>
            {isMinimized ? <br/> : <div style={{'padding': '20px'}}>
                <Table>
                    <thead>
                        <tr>
                            <th></th>
                            <th>Header
                                <InfoButton
                                    id={'header'}
                                    message={
                                        'Headers in the addon drop down view. ' +
                                        'This addon will be placed under this header in ' +
                                        ' the quote page for the type specified.'
                                    }
                                    style={{
                                        'margin': '8px',
                                    }}
                                />
                            </th>
                            <th>Header Order Index
                                <InfoButton
                                    id={'header-order-index'}
                                    message={
                                        'Lower order will give higher precedence in the quote page. ' +
                                        'Header is the order of headers for addons. ' +
                                        'Every addon with the same header should have the same ' +
                                        'header order index.'
                                    }
                                    style={{
                                        'margin': '8px',
                                    }}
                                />
                            </th>
                            <th>
                                Label
                            </th>
                            <th style={{
                                'minWidth': '170px',
                            }}>Addon Order Index
                                <InfoButton
                                    id={'addon-order-index'}
                                    message={
                                        'Lower order will give higher precedence of each ' +
                                        'sign under this header in the quote page. '
                                    }
                                    style={{
                                        'margin': '8px',
                                    }}
                                />
                            </th>
                            <th>In Use</th>
                            <th></th>
                            <th>Save</th>
                            <th>Delete</th>
                            <th>Copy</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            addons.map((addon, index) =>
                                this.renderAddon(addon, index, addons))
                        }
                        <tr>
                            <td /><td /><td />
                            <td><Button
                                color="primary"
                                style={{
                                    'minWidth': '110px',
                                }}
                                onClick={(x) =>
                                    this.insertAddon(addons[addons.length-1], false)
                                }>New Addon</Button></td>
                        </tr>
                    </tbody>
                </Table>
            </div>}
            <div style={{
                'height': '70px',
            }}
            >
            </div>
        </>
    }

    moveType(index, direction) {
        const types = this.state.types
        const swapIndex = direction === 'up' ? index - 1 : index + 1
        if (swapIndex < 0 || swapIndex >= types.length) return

        const current = types[index]
        const neighbor = types[swapIndex]
        const swappedOrderIndex = current.order_index
        current.order_index = neighbor.order_index
        neighbor.order_index = swappedOrderIndex
        types[index] = neighbor
        types[swapIndex] = current
        this.setState({types})

        document.getElementById(
            'move-type-' + direction + '-button-' + swapIndex
        )?.focus()

        Promise.all([
            updateSignType(current),
            updateSignType(neighbor),
        ]).catch((error) => this.props.showError(error))
    }

    renderType(type, addons, index) {
        const isMinimized = this.state.minimizeTypes.find(
                (x) => x === type.id) === undefined

        function MakeLabelInputField(ctx, type, label, varname) {
            return <div style={{
                'marginBottom': '12px',
            }}>
                <Label>{label}</Label>
                <Input
                    type='text'
                    value={type[varname]}
                    onChange={(e) => {
                        type[varname] = e.target.value
                        ctx.setState({})
                    }}
                />
            </div>
        }

        function MakeLabelCheckBoxField(ctx, type, label, varname) {
            return <div style={{
                'marginBottom': '12px',
            }}>
                <Label>{label}</Label>
                <Input
                    type="checkbox"
                    checked={type[varname]}
                    onChange={(e) => {
                        type[varname] = !type[varname]
                        ctx.setState({})
                    }}
                />
            </div>
        }

        // let lastSeenCostLabel = 0
        // let index = -1
        // addons = addons.sort(
        //     (l, r) => {
        //         if (l.cost_order_index == r.cost_order_index) {
        //             if (l.cost_label < r.cost_label) {
        //                 return -1
        //             }
        //             if (l.cost_label > r.cost_label) {
        //                 return 1
        //             }
        //             return l.order_index - r.order_index
        //         }
        //         return l.cost_order_index - r.cost_order_index
        //     }).map((x) => {

        //     if (lastSeenCostLabel !== x.cost_label) {
        //         lastSeenCostLabel = x.cost_label
        //         index += 1
        //     }

        //     x.cost_order_index = index
        //     return x
        // })
        return <>
            {index != null && <Button
                id={'move-type-up-button-' + index}
                style={{
                    'height': '10pt',
                    'margin': '0pt',
                    'padding': '0pt',
                }}
                size='sm'
                disabled={index === 0}
                onClick={() => this.moveType(index, 'up')}>
                <IoIosArrowUp
                    style={{
                        'margin': '0pt',
                        'padding': '0pt',
                        'fontSize': '10pt',
                        'fontWeight': 'bold',
                    }}/>
            </Button>}
            {index != null && <Button
                id={'move-type-down-button-' + index}
                style={{
                    'height': '10pt',
                    'margin': '0pt',
                    'padding': '0pt',
                    'marginRight': '8pt',
                }}
                size='sm'
                disabled={index === this.state.types.length - 1}
                onClick={() => this.moveType(index, 'down')}>
                <IoIosArrowDown
                    style={{
                        'margin': '0pt',
                        'padding': '0pt',
                        'fontSize': '10pt',
                        'fontWeight': 'bold',
                    }}/>
            </Button>}
            <Label
                style={{
                    'fontSize': '30px',
                    'fontWeight': '550',
                }}
            >{type.label}</Label>
            <Button
                style={{
                    'marginLeft': '8pt',
                }}
                onClick={(e) => {
                    if (isMinimized) {
                        const types = this.state.minimizeTypes
                        types.push(type.id)
                        this.setState({
                            'minimizeTypes': types,
                        })
                    } else {
                        const types = this.state.minimizeTypes.filter((x) =>
                            x !== type.id)
                        this.setState({
                            'minimizeTypes': types,
                        })
                    }
                }}
                >{isMinimized ?
                    <IoIosArrowUp
                        style={{
                            'fontSize': '20pt',
                            'fontWeight': '500',
                        }}/>
                    : <IoIosArrowDown
                        style={{
                            'fontSize': '20pt',
                            'fontWeight': '500',
                        }}/>
                }</Button>
            {isMinimized ? <></> :
            <div style={{'padding': '20px'}}>
                {MakeLabelInputField(
                    this, type, 'Label', 'label')}
                {MakeLabelInputField(
                    this, type, 'Minimum Price', 'small_size_cost')}
                {MakeLabelInputField(
                    this, type, 'Square Inch Price', 'medium_size_cost')}
                {MakeLabelInputField(
                    this, type, <>Square Inch Price &ge; 64 Square Inch</>, 'large_size_cost')}
                {MakeLabelInputField(
                    this, type, <>
                        Order Index
                        <InfoButton
                            id={'type-order-index'}
                            message={
                                'Lower order will give higher precedence in the quote page. ' +
                                'We set the order index of Other to be 1000 and all outdated ' +
                                'processes will have a higher than 1000 order index.'
                            }
                            style={{
                                'margin': '8px',
                            }}
                        />
                    </>, 'order_index')}
                {MakeLabelCheckBoxField(
                    this, type, 'In Use', 'inuse')}
                <div style={{
                    'textAlign': 'right',
                }}>
                    <Button
                        style={{
                            'marginRight': '20px',
                        }}
                        color='danger'
                        onClick={(e) => {
                            this.deleteType(type.id)
                        }}
                    >Delete Process</Button>
                    <Button
                        color='success'
                        onClick={(e) => {
                            this.props.turnOnLoader()
                            updateSignType(type).then(
                                (result) => {
                                    this.props.turnOffLoader()
                                },
                                (error) => {
                                    this.props.showError(error)
                                    this.props.turnOffLoader()
                                }
                            )

                        }}
                    >Update</Button>
                </div>
                <br />
                <br />
                {
                    // addons.map((x) => x.header_label).unique()
                    (this.state.typesToHeaderLabels[type.id] || [])
                    .map((x, index) => this.renderCostLabel(
                        addons.filter((addon) =>
                            addon.header_label === x
                        ),
                        index,
                        this.state.typesToHeaderLabels[type.id]
                    ))
                }
                <Button
                    color='primary'
                    onClick={(e) => {
                        if (this.state.typesToHeaderLabels[type.id].indexOf('New') === -1) {
                            this.state.typesToHeaderLabels[type.id].push('New')
                        }
                        this.insertAddon(AddonWithOptions.from({
                            'type_id': type.id,
                            'cost_label': 'New',
                            'header_label': 'New',
                        }), true)
                    }}
                >New Header</Button>
            </div>
            }
            <br />
        </>
    }

    render() {
        // let addons = this.state.addons
        // const headerLabels = addons.map((x) => x.header_label).unique()
        // addons = addons.sort((l, r) => {
        //     if (l.header_label !== r.header_label) {
        //         return headerLabels.indexOf(l.header_label) -
        //             headerLabels.indexOf(r.header_label)
        //     }
        //     return l.order_index - r.order_index
        // })
        return (
            <div style={{'margin': '22px'}}>
            {
                // [
                //     ...this.state.addons.map(x => x.type_label),
                //     ...this.state.types.map(x => x.label),
                // ].unique()
                [...this.state.types, SignType.from({
                    'label': 'All',
                })]
                .map((x, index) => this.renderType(
                    x,
                    this.state.addons.filter((addon) =>
                        addon.type_id === x.id
                    ),
                    // the synthetic "All" row appended above has no id and
                    // isn't in this.state.types - it can't be reordered.
                    index < this.state.types.length ? index : null
                ))
            }
            <Button
                color='success'
                onClick={(e) => {
                    this.props.turnOnLoader()
                    insertSignType(new SignType()).then(
                        (result) => {
                            this.setState((state) => {
                                const types = state.types
                                types.push(SignType.from(result.data.signtype))
                                state.typesToHeaderLabels[result.data.signtype.id] = []

                                return {
                                    'types': types,
                                    'typesToHeaderLabels': this.state.typesToHeaderLabels,
                                }
                            })
                            this.props.turnOffLoader()
                        },
                        (error) => {
                            this.props.showError(error)
                            this.props.turnOffLoader()
                        }
                    )
                }}
                >New Process</Button>
            </div>
        )
    }
}

export { AddonsAdderViewController }

